function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _pt from 'prop-types';
import React, { useState } from 'react';
import { jsx, Global } from '@emotion/core';
import { Input, FormFeedback, Modal, ModalHeader, ModalBody, Row, Col, FormLabelGroup, ModalFooter, Button } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import { withStores } from "../contexts/StoresContext.js";
import useStores from "../hooks/useStores.js";
import i18n from 'i18next';
import "../i18n.js";
import useValidatedState from "../hooks/useValidatedState.js";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ff7d3t",
  styles: "font-family:'Cookie',cursive;font-size:2.5rem;color:black !important;"
} : {
  name: "1ff7d3t",
  styles: "font-family:'Cookie',cursive;font-size:2.5rem;color:black !important;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function SignatureFieldInput(_ref2) {
  var value = _ref2.value,
      error = _ref2.error,
      _ref2$autoFocus = _ref2.autoFocus,
      autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus,
      onChange = _ref2.onChange,
      onKeyDown = _ref2.onKeyDown,
      disabled = _ref2.disabled,
      _ref2$maxLength = _ref2.maxLength,
      maxLength = _ref2$maxLength === void 0 ? Infinity : _ref2$maxLength,
      className = _ref2.className;
  var valid = error === '';
  return jsx(React.Fragment, null, jsx(Input, {
    type: "text",
    autoFocus: autoFocus,
    maxLength: maxLength,
    css: _ref,
    value: value,
    onChange: onChange,
    onKeyDown: onKeyDown,
    disabled: disabled,
    invalid: !valid,
    className: className
  }), !valid && jsx(FormFeedback, null, error));
}

SignatureFieldInput.displayName = "SignatureFieldInput";
SignatureFieldInput.propTypes = {
  value: _pt.string.isRequired,
  error: _pt.oneOfType([_pt.string, _pt.oneOf([null])]),
  autoFocus: _pt.bool,
  onChange: _pt.func.isRequired,
  onKeyDown: _pt.func.isRequired,
  disabled: _pt.bool,
  maxLength: _pt.number,
  className: _pt.string,
  children: _pt.node
};

var SignatureModal = function SignatureModal(_ref3) {
  var isOpen = _ref3.isOpen,
      onClose = _ref3.onClose,
      onSubmit = _ref3.onSubmit,
      locale = _ref3.locale,
      size = _ref3.size;
  i18n.changeLanguage(locale);

  var _useStores = useStores(),
      signatureStore = _useStores.signatureStore;

  var validateFullName = signatureStore.validateFullName,
      validateInitials = signatureStore.validateInitials;

  var _useValidatedState = useValidatedState('', validateFullName),
      _useValidatedState2 = _slicedToArray(_useValidatedState, 3),
      fullName = _useValidatedState2[0],
      fullNameError = _useValidatedState2[1],
      setFullName = _useValidatedState2[2];

  var _useValidatedState3 = useValidatedState('', validateInitials),
      _useValidatedState4 = _slicedToArray(_useValidatedState3, 3),
      initials = _useValidatedState4[0],
      initialsError = _useValidatedState4[1],
      setInitials = _useValidatedState4[2];

  var _useState = useState({
    fullNameErrorMessage: '',
    initialsErrorMessage: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var handleSubmit = function handleSubmit() {
    setErrors({
      fullNameErrorMessage: (fullNameError === null || fullNameError === void 0 ? void 0 : fullNameError.message) || '',
      initialsErrorMessage: (initialsError === null || initialsError === void 0 ? void 0 : initialsError.message) || ''
    });
    var hasErrors = fullNameError || initialsError;
    if (hasErrors) return;
    signatureStore.setSignature(fullName, initials);
    onSubmit(fullName, initials);
    onClose();
  };

  return jsx(Modal, {
    isOpen: isOpen,
    toggle: onClose,
    autoFocus: false,
    backdrop: true,
    zIndex: "10050",
    size: size,
    className: "js-signature-modal"
  }, jsx(Global, {
    styles: {
      '.modal': {
        zIndex: 10050
      }
    }
  }), jsx(ModalHeader, {
    toggle: onClose
  }, i18n.t('signables.headings.setup_signature')), jsx(ModalBody, null, i18n.t('signables.messages.create_your_signature'), jsx(Row, {
    className: "mt-3"
  }, jsx(Col, {
    xs: "9"
  }, jsx(FormLabelGroup, {
    label: i18n.t('signables.labels.your_full_name'),
    stacked: true,
    required: true
  }, jsx(SignatureFieldInput, {
    value: fullName,
    error: errors.fullNameErrorMessage,
    onKeyDown: function onKeyDown(e) {
      if (e.nativeEvent.key === 'Enter') handleSubmit();
    },
    autoFocus: true,
    onChange: function onChange(e) {
      return setFullName(e.target.value);
    },
    maxLength: 26,
    className: "js-full-name-input"
  }))), jsx(Col, {
    xs: "3"
  }, jsx(FormLabelGroup, {
    label: i18n.t('signables.labels.initials'),
    stacked: true,
    required: true
  }, jsx(SignatureFieldInput, {
    value: initials,
    error: errors.initialsErrorMessage,
    onKeyDown: function onKeyDown(e) {
      if (e.nativeEvent.key === 'Enter') handleSubmit();
    },
    onChange: function onChange(e) {
      return setInitials(e.target.value.toUpperCase());
    },
    maxLength: 4,
    className: "js-initials-input"
  }))))), jsx(ModalFooter, null, jsx(Button, {
    color: "primary",
    onClick: handleSubmit,
    className: "js-submit-button"
  }, i18n.t('signables.actions.create_signature'))));
};

SignatureModal.displayName = "SignatureModal";
SignatureModal.propTypes = {
  isOpen: _pt.bool.isRequired,
  onClose: _pt.func.isRequired,
  onSubmit: _pt.func.isRequired,
  locale: _pt.string.isRequired,
  size: _pt.string.isRequired,
  children: _pt.node
};
var SignatureModal$1 = withStores(observer(SignatureModal));
export default SignatureModal$1;